import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'zodiac-taurus', 'ZodiacTaurus', [["path",{"d":"M6 3a6 6 0 0 0 12 0"}],["path",{"d":"M6 15a6 6 0 1 0 12 0a6 6 0 1 0 -12 0"}]]);